import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { getTranslations } from "../Shared/translations"

interface MyProps {
  visible: string;
  onDataChange: (t: any) => any;
  onSave: (t: any) => any;
}

const AddKast: React.FC<MyProps> = ({ visible, onDataChange, onSave }) => {
  let kastNaam = "";
  const t = getTranslations();
  const handleClose = () => {
    onDataChange({ settings: "hidden" });
  };

  const handleSave = () => {
    onSave(kastNaam);
    onDataChange({ settings: "hidden" });
  };

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    kastNaam = event.target.value;
  };

  return (
    <Modal show={visible === "addkast"}>
      <Modal.Header closeButton onClick={handleClose}>
        <Modal.Title>
          <h2>{t.voegKastToe}</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {t.naamKast} <br />
        <input
          type="text"
          onChange={handleTextChange}
          //defaultValue={sessionStorage.getItem("bestandsnaam") || ""}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSave}>
          {t.bewaar}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddKast;
